module.exports = __webpack_public_path__ + "img/facebook.aa1f87da.svg";